import { type HttpClient } from '@/application/interfaces/http-client';

import getRegions from './get-regions';

const RegionService = (httpClient: HttpClient.Instance) => ({
  getRegions: getRegions(httpClient),
});

export default RegionService;
